import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { BrandingModule } from "../branding/branding.module";
import { FooterLegalLinksComponent } from "./footer-legal-links.component";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule.forChild(),
        BrandingModule,
        FooterLegalLinksComponent,
    ],
    exports: [FooterLegalLinksComponent],
})
export class FooterLegalLinksModule {}
